import { ChangeDetectionStrategy, Component, input, Input, signal } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { TooltipDirective } from '@ui';

@Component({
  selector: 'ui-badge',
  standalone: true,
  imports: [IconComponent,TooltipDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div
      uiTooltip
      [tooltipTitle]="tooltipTitleTemplate"
      class="flex justify-between w-full gap-x-4 px-2 py-1 rounded-lg text-neutral-8"
      [class]="bgColorClass()"
    >
      <ng-content />
      @if (icon()) {
        <ui-icon [icon]="icon()!" />
      }
    </div>
    <ng-template #tooltipTitleTemplate>
      {{tooltipBody()}}
    </ng-template>
  `,
})
export class BadgeComponent {
  /**
   * Signal for the icon to be displayed within the badge. Optional.
   */
  icon = input<string | null>(null);
  tooltipBody = input<string | null>(null);

  /**
   * Signal for the color controlling the background of the badge.
   * Accepts predefined values like 'purple', 'blue', etc.
   */
  color = input<'purple' | 'blue' | 'green' | 'red' | 'orange'>('purple');

  /**
   * Computes the CSS class for the badge's background color.
   */
  bgColorClass = () => `bg-${this.color()}-light`;
}
